module.exports = __webpack_public_path__ + "img/binamo-addition.en.4e0aedf5.jpg";